module.exports = __webpack_public_path__ + "img/enrico-pro.2aca4399.jpg";